export { default } from './TitleMultiRowCardsButton';
export type {
  IPrismicTitleMultiRowCardsButtonItem,
  IPrismicTitleMultiRowCardsButtonPrimary,
} from './types';
